// Keep controllers outside Vuex: they are request lifetimes, not serializable UI state.
export function createAnalyticsRequests() {
  const active = new Map();
  return {
    // Only the newest request for a key may update its consumer.
    start(key) {
      if (active.has(key)) active.get(key).abort();
      const controller = new AbortController();
      active.set(key, controller);
      return {
        signal: controller.signal,
        // Cancellation saves network work; this identity check also rejects late responses.
        isCurrent: () => active.get(key) === controller && !controller.signal.aborted,
        // Release this group and cancel any sibling requests left after a failure.
        finish() {
          if (active.get(key) === controller) active.delete(key);
          controller.abort();
        }
      };
    },
    // A selection change or teardown makes every active request obsolete.
    invalidate() {
      active.forEach((controller) => controller.abort());
      active.clear();
    },
    pending: () => active.size > 0
  };
}
